<template>
  <div v-if="tagOptions" class="tag-container">
    <AGCLabel v-if="label" :required="required" :id="id">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel"><span v-html="subLabel"></span></slot>
      </template>
    </AGCLabel>
    <TagAndSubTagsItem
      v-for="(tag, index) in inputVal"
      :key="tag.id"
      :tag-options="tagOptionsSelectable"
      :sub-tag-options="subTagOptions"
      :index="index"
      v-model="inputVal"
      :disabled="disabled"
    ></TagAndSubTagsItem>
    <ButtonAdd
      @click="addTag"
      variant="outline-primary"
      class="border-0"
      :disabled="disabled"
      :style="label ? buttonTopRight : ''"
    >
      添加主要分類
    </ButtonAdd>
    <span v-if="showError" class="limit">(最多只可添加2個添加主要分類)</span>
  </div>
</template>

<script>
import ButtonAdd from '@/components/button/ButtonAdd.vue';
import agcFormElementMixin from '../../mixins/agc-form-element';
import TagAndSubTagsItem from './TagAndSubTagsItem.vue';

export default {
  name: 'MerchantTagAndSubtagsList',
  mixins: [agcFormElementMixin],
  components: {
    ButtonAdd,
    TagAndSubTagsItem,
  },
  props: {
    tagOptions: { type: Array, required: false },
    subTagOptions: { type: Object, required: false },
  },
  data: () => ({ showError: false, buttonTopRight: 'position: absolute; top :0;  right: 0;' }),
  computed: {
    tagOptionsSelectable() {
      if (this.tagOptions) {
        const existingTagIds = this.inputVal.map((tag) => parseInt(tag.id, 10));
        return this.tagOptions.map((option) => {
          if (existingTagIds.includes(option.id)) {
            return { ...option, disabled: true };
          }
          return { ...option, disabled: false };
        });
      }
      return [];
    },
  },
  methods: {
    addTag() {
      if (this.inputVal.length < 2) {
        this.inputVal.push({
          id: null,
          children: [],
        });
      } else {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, 4000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-container {
  position: relative;
}

.limit {
  color: red;
  font-size: 12px;
  display: flex;
  flex-flow: wrap;
}
</style>
